// @flow
import axios from 'lib/defaultClient';

export const listCategories = (): Promise<*> => axios.get('/me/categories');

export const createCategory = (name: string, order: number, parent: string): Promise<*> =>
  axios.post('/me/categories', {
    name,
    order,
    parent,
  });
export const deleteCategory = (id: string): Promise<*> => axios.delete(`/me/categories/${id}`);

export type UpdateCategoryPayload = {
  id: string,
  name: string,
  order: number,
  parent: string,
};

export const updateCategory = ({ id, name, order, parent }: UpdateCategoryPayload): Promise<*> =>
  axios.patch(`/me/categories/${id}`, { name }, { order }, { parent });

export type ReorderCategoryPayload = Array<{
  id: string,
  order: number,
}>;

export const reorderCategories = (categoryOrders: ReorderCategoryPayload): Promise<*> =>
  axios.put('/me/categories/reorder', categoryOrders);

export const followUser = (userId: string) => axios.post(`/me/follow/users/${userId}`);
export const getUserFollow = (userId: string) => axios.get(`/me/follow/users/${userId}`);
export const unfollowUser = (userId: string) => axios.delete(`/me/follow/users/${userId}`);

export type UpdateProfilePayload = {
  managerName?: string,
  displayName?: string,
  shortBio?: string,
  thumbnail?: string,
  mobile?: string,
  bizNumber?: string,
  bizFile?: string,
};

export const updateProfile = ({
  managerName,
  displayName,
  shortBio,
  thumbnail,
  mobile,
  bizNumber,
  bizFile,
}: UpdateProfilePayload) =>
  axios.patch('/me/profile', {
    manager_name: managerName,
    display_name: displayName,
    short_bio: shortBio,
    mobile,
    biz_number: bizNumber,
    thumbnail,
    biz_file: bizFile,
  });

export const createThumbnailSignedUrl = (filename: string) =>
  axios.post('/files/create-url/general', { filename, type: 'profile' });

export const createBizFileSignedUrl = (filename: string) =>
  axios.post('/files/create-url/biz-file', { filename, type: 'biz-file' });

export const createEstimateSignedUrl = (filename: string) =>
  axios.post('/files/create-url/estimate', { filename, type: 'estimate' });

export const createEstimateBoxSignedUrl = (filename: string, estimateId: string) =>
  axios.post('/files/create-url/estimate-box', { filename, type: 'estimate-box', estimateId });

export const generateUnregisterToken = () => axios.get('/me/unregister-token');
export const unregister = (unregisterToken: string) =>
  axios.post('/me/unregister', {
    unregister_token: unregisterToken,
  });

export const getEmailInfo = () => axios.get('/me/email-info');
export const changeEmail = (email: string) => axios.patch('/me/email', { email });
export const changePassword = (password: string) => axios.patch('/me/password', { password });
export const resendCertmail = () => axios.post('/me/resend-certmail');

export type SaveEmailPermissionsPayload = {
  email_notification: boolean,
  email_promotion: boolean,
};
export const saveEmailPermissions = (payload: SaveEmailPermissionsPayload) =>
  axios.patch('/me/email-permissions', payload);

export const updateProfileLinks = (profileLinks: {
  url?: string,
  email?: string,
  linkedin?: string,
  twitter?: string,
  facebook?: string,
}) => axios.patch('/me/profile-links', profileLinks);

export const updateAbout = (content: string) =>
  axios.patch('/me/about', {
    content,
  });



// WEBPACK FOOTER //
// ./src/lib/api/me/index.js